import styled from '@emotion/styled';

import { Box, Typography } from '@mui/material';

type Params = {
    name: string;
    valeu: string;
}

export const TypographyCustom = styled(Typography)(`
    color: white;
    text-transform: uppercase;
    word-break: break-all;
`);

const LabelDetails = ({ name, valeu }: Params) => {
    return (
        <Box>
            <TypographyCustom fontSize='.4375rem' fontWeight={900}>
                {name}
            </TypographyCustom>
            <TypographyCustom fontSize='.75rem' fontWeight={900} paddingTop='.3rem'>
                {valeu}
            </TypographyCustom>
        </Box>
    );
}

export default LabelDetails;